<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                 <global-table
                    :per-page="10"
                    :bordered="true"
                    :table-detail="tableDetail"
                    :table-data="getData"
                    :total-data="totalRows"
                    :hover="true"
                    :striped="false"
                    :fields="fields"
                    :row-edit="cvoVisitData"
                    :redirect-detail="true"
                    :show-add-button="false"
                    :search-by-customer-group="false"
                    caption="<i class='fa fa-align-justify'></i> Customer Listing"
                    addButton="Tambah Customer"
                    @editForm="editForm"
                    @resetForm="resetForm"
                    ></global-table>
            </b-col>
        </b-row>
    </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import loading from "@/templates/Loading.vue";

export default {
    name: "cro_task",
    components: { globalTable, ModelSelect, MultiSelect, loading },
    props: {
        tableDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cvo_visit_data: [],
            loading: true,
            loadingSubmit: false,
            totalRows: null,
            isEdit: false,
            fields: [
                { key: "employee_name", label: "Nama Karyawan", sortable: true },
                { key: "customer_name", label: "Nama Outlet", sortable: true },
                { key: "date_inserted_cvo_visit", label: "Tanggal Insert", sortable: false },
                { key: "activity_name", label: "Kegiatan CVO", sortable: false },
                { key: "action", label: "View Detail", class: "text-center width-100" }
            ],
            cvoVisitData: interfaces.cvo_visit_data,
            label: 'Tambah',
            item_related_customer_group: []
        };
    },
    notifications: {
        showErrorNotification: {
            title: "Error Title",
            message: "Messages",
            type: "error"
        },
        showInfoNotification: {
            title: "Info Title",
            message: "Messages",
            type: "info"
        }
    },
    validations() {
        if (this.isEdit === false) {
            return custom_validation.task_cvo.add;
        } else {
            return custom_validation.task_cvo.edit;
        }
    },
    methods: {
        init: function () {
            this.isEdit = false;
            this.loading = true;
            this.getDropdown();
        },
        getData: function(ctx) {
            this.loading = true;
            let response = axios.post('web/cvo-delivery/all', ctx);
            return response.then((data) => {
                const items = data.data.data;
                this.totalRows = data.data.total_rows;
                this.loading=false;
                return(items)
            }).catch(error => {
                this.expired(error);
                this.loading=false;
                return []
            })
            },
        getDropdown: function () {
            this.axios
                .get("web/dropdown/task-cvo/")
                .then(response => {
                    this.listCoverageNonGT = response.data.coverage_non_gt;
                    this.listCoverageGT = response.data.coverage_gt;
                    this.listCoverageZone = response.data.coverage_zone;
                    this.listEmployee = response.data.employee;
                    this.listCustomerGroup = response.data.coverage_customer_group;
                })
                .catch(error => { })
                .finally(() => { });
        },
        cancelAdd: function () {
            this.$refs.myModalRef.hide();
        },
        editForm: function (editData) {
            this.isEdit = true;
            this.item_related_gt = editData.recreate_related_gt;
            this.item_related_non_gt = editData.recreate_related_non_gt;
            this.item_related_zone = editData.recreate_related_zone;
            this.item_related_customer_group = editData.recreate_related_customer_group;
            this.taskCoverageForm = editData;
            this.taskCoverageForm.related_non_gt = editData.recreate_related_non_gt;
            this.taskCoverageForm.related_gt = editData.recreate_related_gt;
            this.taskCoverageForm.related_zone = [];//editData.recreate_related_zone;
            this.taskCoverageForm.related_customer_group = editData.recreate_related_customer_group;
        },
        resetForm: function () {
            this.isEdit = false;
            this.resetItem();
            for (var a in interfaces.cro_coverage_task) {
                interfaces.cro_coverage_task[a] = null;
            }
            this.taskCoverageForm = interfaces.cro_coverage_task;
        },
        removeForm: function (e) {
            if (confirm("Apakah anda ingin menghapus pembagian tugas ini ?")) {
                this.axios
                    .delete("web/cvo/remove-task/" + e.id)
                    .then(response => {
                        if (response.data.status === 2000) {
                            this.showInfoNotification({
                                title: "Ubah Pembagian",
                                message: response.data.message
                            });
                            this.cancelAdd();
                            //this.$router.push({ path: "all/detail/" + response.data.id });
                        }
                    })
                    .catch(error => {
                        this.expired(error);
                    })
                    .finally(() => {
                        this.loadingSubmit = false;
                        this.init();
                    });
            }
        },
        submitAdd: function (evt) {
            evt.preventDefault();
            if (this.isEdit) {
                if (confirm("Apakah anda ingin merubah pembagian tugas ini ?")) {
                    this.loadingSubmit = true;
                    this.axios
                        .put("web/cvo/update-task/", this.taskCoverageForm)
                        .then(response => {
                            if (response.data.status === 2000) {
                                this.showInfoNotification({
                                    title: "Ubah Pembagian",
                                    message: response.data.message
                                });
                                //this.$router.push({ path: "all/detail/" + response.data.id });
                            }
                        })
                        .catch(error => {
                            this.expired(error);
                        })
                        .finally(() => {
                            this.cancelAdd();
                            this.loadingSubmit = false;
                            this.init();
                        });
                }
            } else {
                if (confirm("Apakah anda ingin menambahkan pembagian tugas ini ?")) {
                    this.loadingSubmit = true;
                    this.axios
                        .post("web/cvo/add-task/", this.taskCoverageForm)
                        .then(response => {
                            if (response.data.status === 2000) {
                                this.showInfoNotification({
                                    title: "Tambah Pembagian",
                                    message: response.data.message
                                });
                                //this.$router.push({ path: "all/detail/" + response.data.id });
                            }
                        })
                        .catch(error => {
                            this.expired(error);
                        })
                        .finally(() => {
                            this.cancelAdd();
                            this.loadingSubmit = false;
                            this.init();
                        });
                }
            }
            //console.log(this.taskCoverageForm)
        },



        onSelectGT(items, lastSelectItem) {
            this.item_related_gt = items;
            this.taskCoverageForm.related_gt = items;
        },

        onSelectNonGT(items, lastSelectItem) {
            this.item_related_non_gt = items;
            this.taskCoverageForm.related_non_gt = items;
        },

        onSelectZone(items, lastSelectItem) {
            this.item_related_zone = items;
            this.taskCoverageForm.related_zone = items;
        },
        onSelectCustomerGroup(items, lastSelectItem) {
            this.item_related_customer_group = items;
            this.taskCoverageForm.related_customer_group = items;
        },
        // deselect option
        resetItem() {
            this.item_related_gt = []; // reset
            this.item_related_non_gt = []; // reset
            this.item_related_zone = []; // reset
            this.item_related_customer_group = []; // reset
        },
        expired: function (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                this.$router.push({ path: "/login" });
                this.showErrorNotification({
                    title: "Token Expired",
                    message: "Your session has been expired"
                });
            } else {
                this.showErrorNotification({
                    title: "Tambah Konsumen",
                    message: error.response.data.message
                });
            }
        }
    },
    mounted() {
        this.init();
    }
};
</script>

<style></style>